import { useEffect, useState } from "react";
import {
  Button,
  Card,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

import useAuth from "../../hooks/useAuth";

import { Add } from "@mui/icons-material";
// import WarnModal from "../../components/WarnModal";
import Pagination from "../../components/Pagination";
import { isValidInput } from "../../utils/validation";
import Loader from "../../helpers/constants/Loader";
import SearchBar2 from "../../components/SearchBar2";
import WarnModal from "../../components/WarnModal";

import { errorToast, successToast } from "../../helpers";
import {
  useAllSubAdminMutation,
  useDeleteSubAdminMutation,
  useUpdateSubAdminStatusMutation,
} from "../../services/subadmin";
import useTranslation from "../../hooks/Translation";
const ManageSubAdmin = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const userData = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [limit, setLimit] = useState<number>(10);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [total_records, settotal_records] = useState<number>(0);
  const [switched, setSwitched] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const [allSubAdmin] = useAllSubAdminMutation();
  const [deleteSubAdmin] = useDeleteSubAdminMutation();
  const [updataSubAdminStatus] = useUpdateSubAdminStatusMutation();

  const handleToggle = async (id: any, status: any) => {
    let body = {
      is_active: !status,
    };
    try {
      // setIsLoading(true)

      const response = await updataSubAdminStatus({ id, body }).unwrap();
      if (response?.status === 200) {
        //  console.log(response.data)
        successToast(response?.data?.message || t.main.subAdminUpdated);
        setIsLoading(false);
        getAllSubAdmin();
      } else {
        errorToast(response?.data?.message || "");
        // setCategoryData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };
  const [subAdmins, setSubAdmins] = useState<any[]>([]);
  const [hidePermission, setHidePermission] = useState<
    Permissions | null | undefined
  >(null);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const getAllSubAdmin = async () => {
    let body = {
      start: 1,
      length: 10,
      search: debouncedSearchTerm,
    };
    //  console.warn(body.length)
    try {
      setIsLoading(true);
      const response = await allSubAdmin(body).unwrap();

      console.warn(response?.data);
      if (response?.status === 200) {
        settotal_records(response?.data?.total_records);
        setTotalPages(Math.ceil(response?.data?.total_records / 10));
        setSubAdmins(response?.data?.response_object);
        setIsLoading(false);
      } else {
        // setCategoryData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const handleDelete = async () => {
    try {
      // setIsLoading(true)
      const response = await deleteSubAdmin(selectedId).unwrap();
      if (response?.status === 200) {
        //  console.log(response.data)
        successToast(
          response?.data?.message || "Sub Admin deleted successfully."
        );
        // setIsLoading(false)
        getAllSubAdmin();
        //  setRolesData(response?.data)
        // console.log()
        //  setRows(response.data.response_object)
        // setCategoryData(response?.data?.response_object);
      } else {
        errorToast(response?.data?.message || "");
        // setCategoryData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  console.log(subAdmins);
  // useEffect(() => {
  //   if (userData && userData?.permission?.length) {
  //     checkPermission();
  //   }
  // }, [userData]);
  useEffect(() => {
    getAllSubAdmin();
  }, [debouncedSearchTerm]);

  function createData(Name: string, Email: string, Phone: string) {
    return { Name, Email, Phone };
  }
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const rows = [createData("Sub Admin", "subadmin@gmail.com", "+971056734321")];

  return (
    <div className="main_loyout">
      <Loader isLoad={isLoading} />
      <div className="dashboard">
        <h1 className="mn_hdng">{t.sideBar.manageSubAdmin}</h1>
      </div>
      <Card className="cards">
        <Box className="cards_header">
          <SearchBar2
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setDebouncedSearchTerm}
            value={searchTerm}
            onCross={() => setSearchTerm("")}
            onChange={(val: any) => {
              if (isValidInput(val.target.value)) {
                setSearchTerm(val.target.value);
              }
            }}
          />
          <Box className="cards_header_right">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-subadmin/add")}
            >
              {<Add />} {t.main.addSubAdmin}
            </Button>
          </Box>
        </Box>
        <TableContainer className="table_container">
          <Box className="heading"></Box>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">S.No</TableCell>
                <TableCell>{t.main.image}</TableCell>
                <TableCell>{t.main.name}</TableCell>
                <TableCell>{t.main.role}</TableCell>
                <TableCell>{t.main.email}</TableCell>
                <TableCell>{t.main.contact}</TableCell>
                <TableCell>{t.main.status}</TableCell>
                <TableCell>{t.main.actions}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subAdmins?.length ? (
                subAdmins?.map((row: any, i: number) => (
                  <TableRow key={row?.id}>
                    <TableCell align="center">
                      {(page - 1) * 10 + i + 1}
                    </TableCell>
                    <TableCell>
                      <figure
                        onClick={() =>
                          navigate(`/manage-users/details/${row?.id}`)
                        }
                        className="user_img"
                      >
                        <img
                          src={
                            row?.profile_picture.media_url ||
                            "/static/images/cr7.png"
                          }
                          alt=""
                        />
                      </figure>
                    </TableCell>
                    <TableCell>{row?.full_name}</TableCell>
                    <TableCell>{row?.sub_role}</TableCell>

                    <TableCell>{row?.email}</TableCell>
                    <TableCell>{row?.country_code + row?.phone_no}</TableCell>
                    <TableCell>
                      <Switch
                        checked={row?.is_active}
                        size="small"
                        // onClick={()=>}
                        onChange={() => {
                          setSelectedId(row?.id);
                          handleToggle(row?.id, row?.is_active);
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Box className="table_actions">
                        <IconButton onClick={() => navigate("edit/" + row?.id)}>
                          <ModeEditIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            setSelectedId(row?.id);
                            setOpen(true);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} sx={{ textAlign: "center" }}>
                    {t.error.noData}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
      {/* <Pagination
        module={subAdmins}
        page={page}
        onPageChange={onPageChange}
        totalPages={totalPages}
        limit={10}
        setLimit={() => {}}
        setPage={() => {}}
      /> */}
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          limit={limit}
          setLimit={setLimit}
          totalRecords={total_records}
        />
      ) : null}
      <WarnModal
        setOpen={setOpen}
        open={open}
        name={"sub-admin"}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default ManageSubAdmin;
